import React from "react";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useRBAC } from "Components/Hooks/useRBAC";

/**
 * Route component that checks permissions before rendering
 */
const ProtectedRoute = ({
  children,
  permission,
  permissions,
  requireAll = false,
  roleLevel,
  redirectTo = "/unauthorized",
  fallback = null,
}) => {
  const { can, canAny, canAll, hasRole } = useRBAC();

  let hasAccess = true;

  // Check role level first (if specified)
  if (roleLevel !== undefined) {
    hasAccess = hasRole(roleLevel);
  }

  // Check permissions (if specified and role check passed)
  if (hasAccess) {
    if (permission) {
      hasAccess = can(permission);
    } else if (permissions && permissions.length > 0) {
      hasAccess = requireAll ? canAll(permissions) : canAny(permissions);
    }
  }

  if (!hasAccess) {
    if (fallback) {
      return fallback;
    }
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  permission: PropTypes.string,
  permissions: PropTypes.arrayOf(PropTypes.string),
  requireAll: PropTypes.bool,
  roleLevel: PropTypes.number,
  redirectTo: PropTypes.string,
  fallback: PropTypes.node,
};

export default ProtectedRoute;
